import React from 'react';
import { TEMPLATE_COLUMNS } from '../../Utils/constants';

/**
 * Table Header Component
 * Renders template table column headers
 * Note: Custom tables now use TableBuilder which has its own header rendering
 */
const TableHeader = ({ table, permissions = {} }) => {
  return (
    <thead>
      <tr>
        {TEMPLATE_COLUMNS.map((column) => (
          <th key={column.key}>
            {column.label}
          </th>
        ))}
        <th className="table-actions-column">Actions</th>
      </tr>
    </thead>
  );
};

export default TableHeader;
